/**
 * TOTP (Two-Factor Authentication) input handling module
 */

let isSubmitting = false;

export function setupPinCodeInput() {
    const pinDigits = document.querySelectorAll('.pin-digit');
    if (pinDigits.length === 0) return;

    pinDigits.forEach((digit, index) => {
        if (index === 0) {
            digit.focus();
        }

        digit.addEventListener('input', (e) => handlePinInput(e, index, pinDigits));
        digit.addEventListener('keydown', (e) => handlePinKeydown(e, index, pinDigits));
        digit.addEventListener('paste', (e) => handlePinPaste(e, pinDigits));

        digit.addEventListener('focus', () => {
            pinDigits.forEach(d => d.classList.remove('error'));
        });
    });
}

function handlePinInput(event, index, pinDigits) {
    const raw = event.target.value;
    const digits = raw.replace(/\D/g, '');

    // No valid digits entered
    if (digits.length === 0) {
        event.target.value = '';
        return;
    }

    // Mobile paste/autofill: multiple digits entered into a single input
    if (digits.length > 1) {
        const available = digits.slice(0, pinDigits.length - index);
        for (let i = 0; i < available.length; i++) {
            pinDigits[index + i].value = available[i];
        }
        const lastFilledIndex = Math.min(index + available.length - 1, pinDigits.length - 1);
        pinDigits[lastFilledIndex].focus();
        autoSubmitIfComplete(pinDigits);
        return;
    }

    // Single digit: enforce maxlength=1 in JS
    event.target.value = digits[0];
    if (index < pinDigits.length - 1) {
        pinDigits[index + 1].focus();
    }
    autoSubmitIfComplete(pinDigits);
}

function handlePinKeydown(event, index, pinDigits) {
    if (event.key === 'Backspace') {
        if (event.target.value === '' && index > 0) {
            pinDigits[index - 1].focus();
            pinDigits[index - 1].value = '';
        }
    } else if (event.key === 'ArrowLeft' && index > 0) {
        pinDigits[index - 1].focus();
    } else if (event.key === 'ArrowRight' && index < pinDigits.length - 1) {
        pinDigits[index + 1].focus();
    } else if (event.key === 'Enter') {
        event.preventDefault();
        autoSubmitIfComplete(pinDigits);
    }
}

function handlePinPaste(event, pinDigits) {
    event.preventDefault();
    const pasteData = (event.clipboardData || window.clipboardData || '').getData('text');
    const digits = pasteData.replace(/\D/g, '').slice(0, 6);

    if (digits.length > 0) {
        for (let i = 0; i < Math.min(digits.length, pinDigits.length); i++) {
            pinDigits[i].value = digits[i];
        }

        const lastFilledIndex = Math.min(digits.length, pinDigits.length) - 1;
        pinDigits[lastFilledIndex].focus();

        autoSubmitIfComplete(pinDigits);
    }
}

function autoSubmitIfComplete(pinDigits) {
    updateTOTPCode(pinDigits);
    const allFilled = Array.from(pinDigits).every(d => /^\d$/.test(d.value));
    if (allFilled && !isSubmitting) {
        isSubmitting = true;
        const loginForm = document.getElementById('loginForm');
        if (loginForm) {
            loginForm.requestSubmit();
        }
        // Reset after a short delay in case submission fails
        setTimeout(() => { isSubmitting = false; }, 2000);
    }
}

export function updateTOTPCode(pinDigits) {
    const digits = pinDigits || document.querySelectorAll('.pin-digit');
    const code = Array.from(digits).map(d => d.value).join('');
    const hiddenField = document.getElementById('totp_code');
    if (hiddenField) {
        hiddenField.value = code;
    }
    return code;
}

export function clearPinCode() {
    const pinDigits = document.querySelectorAll('.pin-digit');
    pinDigits.forEach(digit => {
        digit.value = '';
        digit.classList.remove('error');
    });
    if (pinDigits.length > 0) {
        pinDigits[0].focus();
    }
    const hiddenField = document.getElementById('totp_code');
    if (hiddenField) {
        hiddenField.value = '';
    }
}

export function showPinError(pinDigits) {
    const digits = pinDigits || document.querySelectorAll('.pin-digit');
    digits.forEach(digit => {
        digit.classList.add('error');
        digit.value = '';
    });
    if (digits.length > 0) {
        digits[0].focus();
    }
}

// Make functions available globally for onclick handlers
window.clearPinCode = clearPinCode;
